module.exports = __webpack_public_path__ + "img/d06.6fbf0937.png";